/* this file is transformed by vux-loader */
/* eslint-disable */
import _regenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XInput from "vux/src/components/x-input/index.vue";
import Group from "vux/src/components/group/index.vue";
import Cell from "vux/src/components/cell/index.vue";
import Datetime from "vux/src/components/datetime/index.vue";
import XTextarea from "vux/src/components/x-textarea/index.vue";
import PopupRadio from "vux/src/components/popup-radio/index.vue";
import { inputCheckIOS, uploadImage } from "@/utils/common";
import { addFeedback, getProblemCateList } from "@/api/feedback";
import Vue from "vue";
export default {
  components: {
    Datetime: Datetime,
    XInput: XInput,
    Cell: Cell,
    Group: Group,
    XTextarea: XTextarea,
    PopupRadio: PopupRadio
  },
  data: function data() {
    return {
      styleList: [{
        key: 0,
        value: "--"
      }],
      showShadow: false,
      info: {
        title: "",
        // 标题
        description: "",
        // 问题描述
        place: "",
        // 问题地点
        deadline: "",
        // 整改期限
        cate_id: "",
        // 问题分类id
        feedback_img: [] // 图片上传
      },
      photo_url: [],
      timeOut: null
    };
  },
  mounted: function mounted() {
    // this.from = this.$route.query.from
    // if (sessionStorage.getItem('studentInfo')) {
    //   const studentInfo = JSON.parse(sessionStorage.getItem('studentInfo'))
    //   if (studentInfo !== null) {
    //     this.info = Object.assign(this.info, studentInfo)
    //     this.info.referrer_id = this.info.referrer_id ? this.info.referrer_id : ''
    //   }
    // }
    // this.getCoachLabel()
    this.getProblemCateListEvent();
  },
  methods: {
    checkIOS: function checkIOS() {
      inputCheckIOS();
    },
    addFeedbackHandler: function addFeedbackHandler() {
      if (!this.info.title) {
        Vue.$vux.toast.show({
          type: "warn",
          text: "请输入问题标题后再操作",
          time: 2000
        });
        return;
      } else if (!this.info.cate_id) {
        Vue.$vux.toast.show({
          type: "warn",
          text: "请输入问题分类后再操作",
          time: 2000
        });
        return;
      } else if (!this.info.deadline) {
        Vue.$vux.toast.show({
          type: "warn",
          text: "请输入问题标题后再操作",
          time: 2000
        });
        return;
      }
      this.showShadowEvent();
      this.addFeedbackEvent(this.info);
    },
    addFeedbackEvent: function addFeedbackEvent(param) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$addFeedback, is_error, msg, error;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return addFeedback(param);
            case 1:
              _yield$addFeedback = _context.v;
              is_error = _yield$addFeedback.is_error;
              msg = _yield$addFeedback.msg;
              error = _yield$addFeedback.error;
              _this.hideShadowEvent();
              Vue.$vux.toast.show({
                type: !is_error ? "success" : "warn",
                text: msg || error,
                time: 2000
              });
              if (!is_error) {
                _this.indexClick();
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getProblemCateListEvent: function getProblemCateListEvent() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$getProblemCate, is_error, list, error;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getProblemCateList({});
            case 1:
              _yield$getProblemCate = _context2.v;
              is_error = _yield$getProblemCate.is_error;
              list = _yield$getProblemCate.list;
              error = _yield$getProblemCate.error;
              if (is_error && (!list || !list[0])) {
                Vue.$vux.toast.show({
                  type: "warn",
                  text: error || "类别接口返回数据异常,可能影响操作",
                  time: 2000
                });
              } else {
                //   this.info = list
                _this2.styleList = list.map(function (item) {
                  return {
                    key: item.cate_id,
                    value: item.cate_name
                  };
                });
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    showShadowEvent: function showShadowEvent() {
      var _this3 = this;
      // 显示
      this.$vux.loading.show({
        text: "数据上传中"
      });
      this.showShadow = true;
      this.timeOut = setTimeout(function () {
        _this3.$vux.loading.hide();
        _this3.showShadow = false;
      }, 10000);
    },
    hideShadowEvent: function hideShadowEvent() {
      clearTimeout(this.timeOut);
      this.timeOut = null;
      // 隐藏
      this.$vux.loading.hide();
      this.showShadow = false;
    },
    // 跳转首页
    indexClick: function indexClick(related_no) {
      var routerParam = {
        name: "Index"
      };
      this.$router.push(routerParam);
    },
    deleteImg: function deleteImg(index) {
      this.info.feedback_img.splice(index, 1);
      this.photo_url.splice(index, 1);
      // console.log(index, this.photo_url, this.action_img)
    },
    // 照片上传
    uploadImg: function uploadImg() {
      if (this.info.feedback_img.length >= 6) {
        Vue.$vux.toast.show({
          type: "warn",
          text: "只能添加6张图片",
          time: 2000
        });
        return;
      }
      this.showShadowEvent();
      // 图片名称（feedbackImg：反馈图片；actionImg：工单处理图片）
      uploadImage(this.uploadImageCallback, "feedbackImg");
    },
    uploadImageCallback: function uploadImageCallback(data) {
      // alert(JSON.stringify(data))
      this.info.feedback_img.push(data.imgPath);
      this.photo_url.push(data.imgUrl);
      this.hideShadowEvent();
      // alert(this.formData.photo_url)
    }
  }
};